import { useTranslation } from 'react-i18next';
import { bigIntFormatter, formatPercent } from '@anytag/shared-utils';
import { useGenerateInfluencerProfileLink } from '@anytag/shared-hooks';
import { SocialAccountStatus, SocialAccountType } from '@anytag/graphql';
import {
  PostsSection,
  InfluencerAvatar,
  InfluencerPostDetailsModal,
  InfluencerWidgetInformation
} from '@anytag/shared-molecules';
import { XhsInfluencerProfile } from '../schemaTypes';
import { DefaultProfileWidgetProps } from '../../schemaTypes';
import { StatsSection, ProfileWidgetTemplate } from '../../shared';

type ProfileWidgetProps = DefaultProfileWidgetProps<XhsInfluencerProfile>;

export const ProfileWidget = ({
  className,
  selectButtonProps,
  profile: {
    id,
    age,
    name,
    posts,
    avatar,
    gender,
    country,
    averageLikes,
    averageViews,
    socialAccountId,
    socialAccountStatus,
    socialAccountFollowers,
    socialAccountEngagementViewsRate,
    socialAccountEngagementFollowersRate
  }
}: ProfileWidgetProps) => {
  const { t } = useTranslation();
  const { generateProfileLink } = useGenerateInfluencerProfileLink();

  const isSignedUp = socialAccountStatus === SocialAccountStatus.SIGNED_UP;
  const stats = [
    { label: t('HeaderColumn.Followers'), value: bigIntFormatter(socialAccountFollowers || 0) },
    { label: t('HeaderColumn.Egg Rate by followers'), value: formatPercent(socialAccountEngagementFollowersRate) },
    { label: t('HeaderColumn.Egg Rate by views'), value: formatPercent(socialAccountEngagementViewsRate) },
    { label: t('HeaderColumn.Avg Views'), value: bigIntFormatter(averageViews || 0, 0) },
    { label: t('HeaderColumn.Avg Likes'), value: bigIntFormatter(averageLikes || 0, 0) }
  ];
  const profileUrl = generateProfileLink(id, {
    filter: {
      id: String(socialAccountId),
      sm: SocialAccountType.XHS
    }
  });

  return (
    <ProfileWidgetTemplate className={className} selectButtonProps={selectButtonProps}>
      <InfluencerAvatar size="80px" src={avatar} socialAccountType={SocialAccountType.XHS} />

      <InfluencerWidgetInformation
        age={age}
        name={name}
        gender={gender}
        country={country}
        profileUrl={profileUrl}
        isSignedUp={isSignedUp}
      />

      <StatsSection id={id} stats={stats} />

      <PostsSection posts={posts} influencerId={Number(id)} css={{ marginLeft: '16px' }} />
      <InfluencerPostDetailsModal posts={posts} />
    </ProfileWidgetTemplate>
  );
};
